import { JsonViewer as e } from "./JsonViewer.js"
customElements.define("json-viewer", e)
